<template>
	<div class="bigBox">
		<div class="leftCont">
			<div class="banner2">
				<div class="mendio">
					<div class="topFar">
						<div class="name">构建生态系统，提升品牌价值</div>
						<div class="Intro">品牌、连锁生态解决方案提供</div>
						<el-button type="text" class="Ufree" @click="goCont"><span 
							style="color: #fff !important;margin-left: unset !important;">预约咨询</span></el-button>
						<!--
						<el-button type="text" class="Ufree" @click="dvSaas = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(外卖)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvQuan = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(MOMI互推)</span></el-button>
						<el-button type="text" class="Ufree" @click="dvStore = true"><span style="color: #fff !important;margin-left: unset !important;">立即体验(商城)</span></el-button>-->
						<div class="Comuni">咨询电话：159 8989 7729</div>
					</div>
				</div>
			</div>
			<div class="smTab"> 
				<div class="sm-tab-box" style='display:none;'>
					<div @click="handleChange(1)" :class="cssStr1">品牌商解决方案</div>
				</div>
				<div @click="handleChange(2)" class="sm-tab-box" style='display:none;'>
					<div :class="cssStr2">MOMI互推</div>
				</div>
				<div class="sm-tab-box" style='display:none;'>
					<div @click="handleChange(3)" :class="cssStr3">餐饮外卖解决方案</div>
				</div> 
			</div>
			<div class="pBox" v-if="cssVal==1">
				<p>&nbsp;</p>
				<div class="x-prog">
					<img mode="widthFix" src="../assets/images/prog/mall/01.png" class="x-img" /> 
					<img mode="widthFix" src="../assets/images/prog/mall/03.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/04.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/05.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/06.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/07.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/08.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/09.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/10.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/11.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/12.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/13.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/mall/14.png" class="x-img" /> 
				</div>
			</div> 
			<div class="pBox" v-if="cssVal==3">
				<div class="x-prog">
					<img mode="widthFix" src="../assets/images/prog/food/01.png" class="x-img" /> 
					<img mode="widthFix" src="../assets/images/prog/food/03.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/04.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/05.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/06.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/07.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/08.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/09.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/10.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/11.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/12.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/13.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/14.png" class="x-img" />
					<img mode="widthFix" src="../assets/images/prog/food/15.png" class="x-img" /> 
				</div>
			</div>
		
			<msg-foot></msg-foot>
		</div>
		<right-cont :activeIndex="activeIndex"></right-cont>
		<!-- <right-cont :dialogVisible="dvSaas"></right-cont>
		<right-cont :dialogVisible="dvQuan"></right-cont>
		<right-cont :dialogVisible="dvStore"></right-cont> -->
		<el-dialog title="" :visible.sync="dvSaas" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/saas_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvQuan" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/qr_tool.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
		<el-dialog title="" :visible.sync="dvStore" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/store_try.jpg" />
				<div class="free-use">扫码立即体验</div>
			</div>
		</el-dialog>
	</div>

</template>

<script>
	import navBar from '../components/navBar';
	import msgFoot from '../components/msgFoot.vue'
	import rightCont from '../components/rightCont.vue'
	export default {
		components: {
			navBar,
			msgFoot,
			rightCont
		},
		data() {
			return {
				activeIndex: '2',
				dialogVisible: false,
				dvSaas: false,
				dvQuan: false,
				dvStore: false,
				cssVal: 1,
				cssStr1: 'sm-tab-cont-active',
				cssStr2: 'sm-tab-cont',
				cssStr3: 'sm-tab-cont',
				cssStr4: 'sm-tab-cont',
				cssStr5: 'sm-tab-cont'
			}
		},
		methods: {
			goCont()
			{  
				console.log('xxxxzz', this.$children[2]) 
				rightCont.openMe(this.$children[2]);
			},
			handleClose(done) {
				done();
			},
			handleChange(e) {
				var top = Math.floor(document.documentElement.scrollTop)
				console.log(top, "=====")
				this.cssVal = e
				if (this.cssVal == 1) {
					this.cssStr1 = 'sm-tab-cont-active'
					this.cssStr2 = 'sm-tab-cont'
					this.cssStr3 = 'sm-tab-cont'
					this.cssStr4 = 'sm-tab-cont'
					this.cssStr5 = 'sm-tab-cont'
				} else if (this.cssVal == 3) {
					this.cssStr1 = 'sm-tab-cont'
					this.cssStr2 = 'sm-tab-cont'
					this.cssStr3 = 'sm-tab-cont-active'
					this.cssStr4 = 'sm-tab-cont'
					this.cssStr5 = 'sm-tab-cont'
				} else if (this.cssVal == 4) {
					this.cssStr1 = 'sm-tab-cont'
					this.cssStr2 = 'sm-tab-cont'
					this.cssStr3 = 'sm-tab-cont'
					this.cssStr4 = 'sm-tab-cont-active'
					this.cssStr5 = 'sm-tab-cont'
				} else if (this.cssVal == 5) {
					this.cssStr1 = 'sm-tab-cont'
					this.cssStr2 = 'sm-tab-cont'
					this.cssStr3 = 'sm-tab-cont'
					this.cssStr4 = 'sm-tab-cont'
					this.cssStr5 = 'sm-tab-cont-active'
				} else {
					this.cssStr2 = 'sm-tab-cont-active'
					this.cssStr1 = 'sm-tab-cont'
					this.cssStr3 = 'sm-tab-cont'
					this.cssStr4 = 'sm-tab-cont'
					this.cssStr5 = 'sm-tab-cont'
				}
			}
		},
		mounted() {
			window.scroll(0, 0);
			if (this.cssVal == 1) {
				this.cssStr1 = 'sm-tab-cont-active'
				this.cssStr2 = 'sm-tab-cont'
			} else {
				this.cssStr2 = 'sm-tab-cont-active'
				this.cssStr1 = 'sm-tab-cont'
			}
		}
	}
</script>

<style>
	.newBox {
		background-color: #fafbfc;
		width: 100%;
		padding-bottom: 40px;
	}

	@media screen and (max-width: 600px) {
		.chainT {
			padding-top: 56px;
		}

		.chanPicts {
			width: 100%;
		}

		.userInset {
			color: red;
			font-size: 0.5rem;
		}

		.smTab {
			background-color: #eff0f3;
			display: flex;
		}

		.sm-tab-box {
			flex: 1;
		}

		.sm-tab-cont {
			width: 19vw;
			margin: 0 auto;
			text-align: center;
			cursor: pointer;
			height: 4rem;
			line-height: 4rem;
			font-size: 2rem;
			color: #777;
			margin-bottom: 0.5rem;
			margin-top: 1rem;
		}

		.sm-tab-cont-active {
			width: 19vw;
			margin: 0 auto;
			text-align: center;
			cursor: pointer;
			height: 4rem;
			line-height: 4rem;
			font-size: 2rem;
			color: #777;
			margin-bottom: 5rem;
			color: #ff6a00;
			border-bottom: 1px #ff6a00 solid;
			margin-bottom: 0.5rem;
			margin-top: 1rem;
		}
	}

	@media screen and (min-width: 600px) and (max-width:1200px) {
		.chainT {
			padding-top: 56px;
		}

		.chanPicts {
			width: 100%;
		}

		.userInset {
			color: red;
			font-size: 1rem;
		}

		.smTab {
			background-color: #eff0f3;
			display: flex;
		}

		.sm-tab-box {
			flex: 1;
		}

		.sm-tab-cont {
			width: 48vw;
			margin: 0 auto;
			text-align: center;
			cursor: pointer;
			height: 4rem;
			line-height: 4rem;
			font-size: 2rem;
			color: #777;
			margin-bottom: 0.5rem;
			margin-top: 2rem;
		}

		.sm-tab-cont-active {
			width: 19vw;
			margin: 0 auto;
			text-align: center;
			cursor: pointer;
			height: 4rem;
			line-height: 4rem;
			font-size: 2rem;
			color: #777;
			margin-bottom: 5rem;
			color: #ff6a00;
			border-bottom: 1px #ff6a00 solid;
			margin-bottom: 0.5rem;
			margin-top: 2rem;
		}
	}

	.x-prog {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 50px
	}

	.x-img {
		width: 100%;
	}

	@media screen and (min-width: 1200px) {
		.smTab {
			background-color: #eff0f3;
			display: flex;
		}

		.sm-tab-box {
			flex: 1;
		}

		.sm-tab-cont {
			width: 160px;
			margin: 0 auto;
			text-align: center;
			cursor: pointer;
			height: 70px;
			line-height: 70px;
			font-size: 18px;
			color: #777;
			margin-bottom: 12px;
		}

		.sm-tab-cont-active {
			width: 160px;
			margin: 0 auto;
			text-align: center;
			cursor: pointer;
			height: 70px;
			line-height: 70px;
			font-size: 20px;
			color: #ff6a00;
			border-bottom: 2px #ff6a00 solid;
			margin-bottom: 12px;
		}

		.pointBox {
			display: flex;
			align-items: center;
			margin-top: 24px;
		}

		.pointText {
			flex: 1;
			font-size: 18px;
			color: #333;
			line-height: 25px;
			padding-left: 16px;
			text-align: left;
		}

		.point {
			width: 8px;
			height: 8px;
			background-color: #8558fa;
			border-radius: 50%;
		}

		.ContPic {
			width: 100%;
		}

		.chanPicts {
			height: 363px;
		}

		.chain {
			padding-bottom: 30px;
		}
	}
</style>
